import { style } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TraceClassDecorator } from '@sentry/angular';
import { URLS } from 'src/app/constant/constant';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
    selector: 'app-home-top-bar',
    templateUrl: './home-top-bar.component.html',
    styleUrls: ['./home-top-bar.component.css', './../../portal-home/login-home/login-home.component.css'],
})
// 'src/app/components/portal-home/login-home/login-home.component.css'
@TraceClassDecorator()
export class HomeTopBarComponent implements OnInit {
    provider_img: string = '';
    slug: string = "";
    is_primary_provider: boolean = false;
    is_uk_country: boolean = false;

    constructor(
        private router: Router,
        private utilitiesService: UtilitiesService,
        private readonly providerstateService: ProviderStateService
    ) { }

    newChange(): void {
        this.router.navigate(['/' + this.slug + '/news']);
    }

    date_of_birth: Date = null;
    async ngOnInit(): Promise<void> {
        this.slug = this.providerstateService.getProviderSlug();
        this.provider_img = this.providerstateService.getLogoUrl();
        if (URLS.IS_UK) {
            this.is_uk_country = true;
        }
        this.is_primary_provider = this.providerstateService.getIsPrimaryProvider();
        if (this.is_primary_provider) {
            await this.setWidthNav();
        }
    }


    RouterNavigation(path: string) {
        this.router.navigate(['/' + this.slug + '/' + path]);
    }

    // function setWidthNav() {
    async setWidthNav() {
        // var ele = document.getElementById("mySidepanel");
        // ele.style.width = "0px";
        let ele = <HTMLElement>document.getElementById("mySidepanel");
        ele.style.width = "0px";
    }

    // function openNav() {
    openNav() {
        document.getElementById("mySidepanel").style.width = "280px";
    }

    // function closeNav() {
    closeNav() {
        document.getElementById("mySidepanel").style.width = "0";
    }

    // function toggleNav() {
    toggleNav() {
        // let ele = document.getElementById("mySidepanel");
        if (document.getElementById("mySidepanel").style.width !== "0px") {
            this.closeNav()
        }
        else if (document.getElementById("mySidepanel").style.width === "0px") {
            this.openNav()
        }
    }

    async openLink(base_url_name: string, link: string, target: string): Promise<void> {
        await this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
    }


}
